<template>
  <div>
    <b-row>
      <b-col md="4">
        <b-card>
          <template v-slot:header>
            <!-- Subtitle -->
            <h6 class="surtitle">Annual Progress</h6>
            <!-- Title -->
            <h5 class="h3 mb-0">Closed Volume</h5>
          </template>
          <div class="chart-area">
            <doughnut-chart
              :height="350"
              :chart-data="volumeChart.chartData"
              :extra-options="extraOptions"
            >
            </doughnut-chart>
          </div>
          <div class="stats-section d-flex flex-column align-items-center position-absolute">
            <h3 class="mb-0 px-3 pb-2 top-stat">{{ scores.closed_volume | currency }}</h3>
            <h3 class="mb-0 pt-2">{{ volume | currency }}</h3>
          </div>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card>
          <template v-slot:header>
            <!-- Subtitle -->
            <h6 class="surtitle">Annual Progress</h6>
            <!-- Title -->
            <h5 class="h3 mb-0">Closed Units</h5>
          </template>
          <div class="chart-area">
            <doughnut-chart
              :height="350"
              :chart-data="unitsChart.chartData"
              :extra-options="extraOptions"
            >
            </doughnut-chart>
          </div>
          <div class="stats-section d-flex flex-column align-items-center position-absolute">
            <h3 class="mb-0 px-3 pb-2 top-stat">{{ scores.closed_units }}</h3>
            <h3 class="mb-0 pt-2">{{ units }}</h3>
          </div>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card>
          <template v-slot:header>
            <!-- Subtitle -->
            <h6 class="surtitle">Annual Progress</h6>
            <!-- Title -->
            <h5 class="h3 mb-0">Total Conversations</h5>
          </template>
          <div class="chart-area">
            <doughnut-chart
              :height="350"
              :chart-data="conversationsChart.chartData"
              :extra-options="extraOptions"
            >
            </doughnut-chart>
          </div>
          <div class="stats-section d-flex flex-column align-items-center position-absolute">
            <h3 class="mb-0 px-3 pb-2 top-stat">{{ scores.conversations }}</h3>
            <h3 class="mb-0 pt-2">{{ conversations }}</h3>
          </div>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card>
          <template v-slot:header>
            <!-- Subtitle -->
            <h6 class="surtitle">Annual Progress</h6>
            <!-- Title -->
            <h5 class="h3 mb-0">Total Appointments Held</h5>
          </template>
          <div class="chart-area">
            <doughnut-chart
              :height="350"
              :chart-data="appointmentsChart.chartData"
              :extra-options="extraOptions"
            >
            </doughnut-chart>
          </div>
          <div class="stats-section d-flex flex-column align-items-center position-absolute">
            <h3 class="mb-0 px-3 pb-2 top-stat">{{ scores.appt_held }}</h3>
            <h3 class="mb-0 pt-2">{{ appointments }}</h3>
          </div>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card>
          <template v-slot:header>
            <!-- Subtitle -->
            <h6 class="surtitle">Annual Progress</h6>
            <!-- Title -->
            <h5 class="h3 mb-0">Total Agreements Signed</h5>
          </template>
          <div class="chart-area">
            <doughnut-chart
              :height="350"
              :chart-data="agreementsChart.chartData"
              :extra-options="extraOptions"
            >
            </doughnut-chart>
          </div>
          <div class="stats-section d-flex flex-column align-items-center position-absolute">
            <h3 class="mb-0 px-3 pb-2 top-stat">{{ scores.signed_agreements }}</h3>
            <h3 class="mb-0 pt-2">{{ agreements }}</h3>
          </div>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card>
          <template v-slot:header>
            <!-- Subtitle -->
            <h6 class="surtitle">Annual Progress</h6>
            <!-- Title -->
            <h5 class="h3 mb-0">Total Ambassadors Added</h5>
          </template>
          <div class="chart-area">
            <doughnut-chart
              :height="350"
              :chart-data="ambassadorsChart.chartData"
              :extra-options="extraOptions"
            >
            </doughnut-chart>
          </div>
          <div class="stats-section d-flex flex-column align-items-center position-absolute">
            <h3 class="mb-0 px-3 pb-2 top-stat">{{ scores.ambassadors_added }}</h3>
            <h3 class="mb-0 pt-2">{{ ambassadors }}</h3>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DoughnutChart from '@/components/Charts/DoughnutChart';
import * as chartConfigs from '@/components/Charts/config';
import { Charts } from "@/components/Charts/config";

export default {
  props: {
    goals: null,
    scores: null,
  },
  components: {
    DoughnutChart
  },
  data() {
    return {
      volumeChart: {
        chartData: {
          labels: [
            'Progress',
            'Goal'
          ],
          datasets: [{
            data: [],
            backgroundColor: [
              Charts.colors.theme['success'],
              Charts.colors.theme['secondary'],
            ],
            label: 'Annual Volume Progress'
          }],
        },
      },
      unitsChart: {
        chartData: {
          labels: [
            'Progress',
            'Goal'
          ],
          datasets: [{
            data: [],
            backgroundColor: [
              Charts.colors.theme['success'],
              Charts.colors.theme['secondary'],
            ],
            label: 'Annual Volume Progress'
          }],
        },
      },
      conversationsChart: {
        chartData: {
          labels: [
            'Progress',
            'Goal'
          ],
          datasets: [{
            data: [],
            backgroundColor: [
              Charts.colors.theme['success'],
              Charts.colors.theme['secondary'],
            ],
            label: 'Annual Volume Progress'
          }],
        },
      },
      appointmentsChart: {
        chartData: {
          labels: [
            'Progress',
            'Goal'
          ],
          datasets: [{
            data: [],
            backgroundColor: [
              Charts.colors.theme['success'],
              Charts.colors.theme['secondary'],
            ],
            label: 'Annual Volume Progress'
          }],
        },
      },
      agreementsChart: {
        chartData: {
          labels: [
            'Progress',
            'Goal'
          ],
          datasets: [{
            data: [],
            backgroundColor: [
              Charts.colors.theme['success'],
              Charts.colors.theme['secondary'],
            ],
            label: 'Annual Volume Progress'
          }],
        },
      },
      ambassadorsChart: {
        chartData: {
          labels: [
            'Progress',
            'Goal'
          ],
          datasets: [{
            data: [],
            backgroundColor: [
              Charts.colors.theme['success'],
              Charts.colors.theme['secondary'],
            ],
            label: 'Annual Volume Progress'
          }],
        },
      },
      extraOptions: {
        responsive: true,
        legend: {
          position: 'top',
        },
        animation: {
          animateScale: true,
          animateRotate: true
        }
      }
    }
  },
  computed: {
    gci() {
      return this.goals.gci;
    },
    commission() {
      return this.goals.avg_sale_price * (this.goals.avg_commission_percent / 100);
    },
    units() {
      return this.commission > 0 ? Math.round(this.goals.gci / this.commission) : 0;
    },
    conversations() {
      return 200 * this.units;
    },
    appointments() {
      return 4 * this.units;
    },
    agreements() {
      return 2 * this.units;
    },
    ambassadors() {
      return 6 * this.units;
    },
    volume() {
      return this.goals.avg_sale_price * this.units;
    }
  },
  methods: {
    mapScores() {
      this.volumeChart.chartData.datasets[0].data = [this.scores.closed_volume, this.volume];
      this.unitsChart.chartData.datasets[0].data = [this.scores.closed_units, this.units];
      this.conversationsChart.chartData.datasets[0].data = [this.scores.conversations, this.conversations];
      this.appointmentsChart.chartData.datasets[0].data = [this.scores.appt_held, this.appointments];
      this.agreementsChart.chartData.datasets[0].data = [this.scores.signed_agreements, this.agreements];
      this.ambassadorsChart.chartData.datasets[0].data = [this.scores.ambassadors_added, this.ambassadors];
    }
  },
  created() {
    this.mapScores();
  }
};
</script>
<style lang="scss">
.stats-section {
  left: 0;
  right: 0;
  top: 50%;
  bottom: 50%;

  .top-stat {
    border-bottom: 1px solid;
  }
}
</style>